<!-- AssistantBanner.vue — at the top of every dialog while an assistant is in a participant's
     account (useAssistantVisit), as the fullstack's (base-layer Dialog/AssistantBanner.vue):
     inside the dialog, as a page banner would sit under it. Done signs out; the assistant then
     signs in again as themselves. -->

<template>
  <div v-if="isVisit" class="assistantBanner" role="status">
    <span>You’re in {{ name }}’s account as their assistant</span>
    <button type="button" class="done" @click="signOut">Done</button>
  </div>
</template>

<script setup>
import {useAssistantVisit} from "@/composables/useAssistantVisit";

const {isVisit, name} = useAssistantVisit();

async function signOut() {
  await window.Clerk?.signOut({redirectUrl: `${window.location.origin}/`});
}
</script>

<style scoped>
.assistantBanner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 0 8px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #fff4d6;
  color: #3d2f00;
  font-size: 13px;
  line-height: 1.3;
  text-align: left;
}
/* global.css button styles reset (CLAUDE.md § Vue conventions), then its own outline */
.done {
  flex: none;
  min-width: 0;
  padding: 2px 10px;
  border: 1px solid #8a6d00;
  border-radius: 999px;
  background: transparent;
  box-shadow: none;
  color: inherit;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.done:hover {
  background: rgba(0, 0, 0, 0.06); /* DESIGN.md § 15 */
}
</style>
